import decline from "../assets/icons/decline.svg";
import accept from "../assets/icons/accept.svg";
import accept_dark from "../assets/icons/accept_dark.svg";
import import_icon from "../assets/icons/import.svg";
import export_icon from "../assets/icons/export.svg";
import add from "../assets/icons/add.svg";
import arrow from "../assets/icons/arrow.svg";
import add_btn_dark from "../assets/icons/add_btn_dark.svg";
import add_dark from "../assets/icons/add_dark.svg";
import add_blue from "../assets/icons/add_blue.svg";
import add_blue_dark from "../assets/icons/add_blue_dark.svg";
import at_icon from "../assets/icons/at-icon.svg";
import pen from "../assets/icons/pen.svg";
import pen_dark from "../assets/icons/pen_dark.svg";
import search from "../assets/icons/search.svg";
import search_dark from "../assets/icons/search_dark.svg";
import grid from "../assets/icons/grid.svg";
import grid_dark from "../assets/icons/grid_dark.svg";
import chart from "../assets/icons/chart.svg";
import chart_dark from "../assets/icons/chart_dark.svg";
import dashboard from "../assets/icons/dashboard.svg";
import dashboard_dark from "../assets/icons/dashboard_dark.svg";
import vehicle from "../assets/icons/vehicle.svg";
import vehicle_dark from "../assets/icons/vehicle_dark.svg";
import vehicle_grey from "../assets/icons/vehicle_grey.svg";
import user from "../assets/icons/user.svg";
import user_dark from "../assets/icons/user_dark.svg";
import calendar from "../assets/icons/calendar.svg";
import calendar_dark from "../assets/icons/calendar_dark.svg";
import bell from "../assets/icons/bell.svg";
import dark from "../assets/icons/dark.svg";
import dark_dark from "../assets/icons/dark_dark.svg";
import light from "../assets/icons/light.svg";
import light_dark from "../assets/icons/light_dark.svg";
import serbian from "../assets/icons/serbia.svg";
import hamburger from "../assets/icons/hamburger.svg";
import close from "../assets/icons/close.svg";
import close_gray from "../assets/icons/close_gray.svg";
import close_white from "../assets/icons/close_white.svg";
import close_neutral from "../assets/icons/close_neutral.svg";
import save_icon from "../assets/icons/save.svg";
import save_blue from "../assets/icons/save_blue.svg";
import tag_x from "../assets/icons/tag_x.svg";
import change_label from "../assets/icons/change_label.svg";
import change_label_dark from "../assets/icons/change_label_dark.svg";
import arrow_down from "../assets/icons/arrow_down.svg";
import arrow_down_dark from "../assets/icons/arrow_down_dark.svg";
import arrow_left from "../assets/icons/arrow_left.svg";
import send from "../assets/icons/send.svg";
import action from "../assets/icons/action.svg";
import download from "../assets/icons/download.svg";
import download_dark from "../assets/icons/download_dark.svg";
import unlock_password from "../assets/icons/unlock-password.svg";
import unlock_password_dark from "../assets/icons/unlock-password-dark.svg";
import lock_password from "../assets/icons/lock-password.svg";
import lock_password_dark from "../assets/icons/lock-password-dark.svg";
import upload_img from "../assets/icons/upload_img.svg";
import check_in from "../assets/icons/check_in.svg";
import check_in_dark from "../assets/icons/check_in_dark.svg";
import check_out from "../assets/icons/check_out.svg";
import check_out_dark from "../assets/icons/check_out_dark.svg";
import maximize from "../assets/icons/maximize.svg";
import logout from "../assets/icons/logout.svg";
import logout_dark from "../assets/icons/logout_dark.svg";
import language from "../assets/icons/language.svg";
import language_dark from "../assets/icons/language_dark.svg";
import successfully_added from "../assets/icons/successfully_added.svg";
import error from "../assets/icons/error.svg";
import expandable_navbar from "../assets/icons/expandable-navbar.svg";
import expandable_navbar_dark from "../assets/icons/expandable-navbar-dark.svg";
import collapse_navbar from "../assets/icons/collapse-navbar.svg";
import collapse_navbar_dark from "../assets/icons/collapse-navbar-dark.svg";
import menu_arrow_left from "../assets/icons/menu-arrow-left.svg";
import menu_arrow_left_dark from "../assets/icons/menu-arrow-left-dark.svg";
import menu_arrow_left_blue from "../assets/icons/menu-arrow-left-blue.svg";
import menu_arrow_right from "../assets/icons/menu-arrow-right.svg";
import menu_arrow_right_dark from "../assets/icons/menu-arrow-right-dark.svg";
import menu_arrow_right_blue from "../assets/icons/menu-arrow-right-blue.svg";
import info from "../assets/icons/info.svg";
import required from "../assets/icons/required.svg";
import warning from "../assets/icons/warning.svg";
import trash_bin from "../assets/icons/trash-bin.svg";
import trash_bin_dark from "../assets/icons/trash-bin_dark.svg";
import trash_red from "../assets/icons/trash_red.svg";
import pen_edit from "../assets/icons/pen-edit.svg";
import pdf from "../assets/icons/pdf.svg";
import link from "../assets/icons/link.svg";
import link_dark from "../assets/icons/link_dark.svg";
import profile from "../assets/icons/profile.svg";
import profile_dark from "../assets/icons/profile_dark.svg";
import maximize_dark from "../assets/icons/maximize_dark.svg";
import minimize from "../assets/icons/minimize.svg";
import minimize_dark from "../assets/icons/minimize_dark.svg";
import arrow_sort_down from "../assets/icons/arrow-sort-down.svg";
import arrow_sort_up from "../assets/icons/arrow-sort-up.svg";
import arrow_sort_down_dark from "../assets/icons/arrow-sort-down-dark.svg";
import arrow_sort_up_dark from "../assets/icons/arrow-sort-up-dark.svg";
import change_password from "../assets/icons/change-password.svg";
import change_password_dark from "../assets/icons/change-password-dark.svg";
import event_groups_blue from "../assets/icons/event_groups_blue.svg";
import event_groups_grey from "../assets/icons/event_groups_grey.svg";
import event_persons_blue from "../assets/icons/event_persons_blue.svg";
import event_persons_grey from "../assets/icons/event_persons_grey.svg";
import event_users_blue from "../assets/icons/event_users_blue.svg";
import event_users_grey from "../assets/icons/event_users_grey.svg";
import remove from "../assets/icons/remove.svg";
import remove_dark from "../assets/icons/remove_dark.svg";
import email_template from "../assets/icons/email_template.svg";
import email_template_dark from "../assets/icons/email_template_dark.svg";
import send_acc from "../assets/icons/send_acc.svg";
import location_pin from "../assets/icons/location_pin.svg";
import camera from "../assets/icons/camera.svg";
import camera_dark from "../assets/icons/camera_dark.svg";
import accreditation from "../assets/icons/accreditation.svg";
import accreditation_dark from "../assets/icons/accreditation_dark.svg";
import generate_accr from "../assets/icons/generate_accr.svg";
import generate_accr_dark from "../assets/icons/generate_accr_dark.svg";
import qr from "../assets/icons/qr.svg";
import edit_image from "../assets/icons/edit_image.svg";
import edit_image_dark from "../assets/icons/edit_image_dark.svg";
import edit_image_blue from "../assets/icons/edit_image_blue.svg";
import country from "../assets/icons/country.svg";
import country_dark from "../assets/icons/country_dark.svg";

export default {
  decline,
  accept,
  accept_dark,
  import_icon,
  export_icon,
  add,
  arrow,
  add_dark,
  add_blue,
  add_blue_dark,
  at_icon,
  pen,
  pen_dark,
  search,
  search_dark,
  grid,
  grid_dark,
  user,
  user_dark,
  calendar,
  calendar_dark,
  bell,
  dark,
  dark_dark,
  light,
  light_dark,
  serbian,
  hamburger,
  close,
  close_gray,
  close_white,
  close_neutral,
  save: save_icon,
  save_blue,
  tag_x,
  change_label,
  change_label_dark,
  arrow_down,
  arrow_down_dark,
  arrow_left,
  send,
  action,
  download,
  unlock_password,
  unlock_password_dark,
  lock_password,
  lock_password_dark,
  upload_img,
  check_in,
  check_in_dark,
  check_out,
  check_out_dark,
  maximize,
  logout,
  logout_dark,
  language,
  language_dark,
  successfully_added,
  error,
  expandable_navbar,
  expandable_navbar_dark,
  collapse_navbar,
  collapse_navbar_dark,
  menu_arrow_left,
  menu_arrow_left_dark,
  menu_arrow_left_blue,
  menu_arrow_right,
  menu_arrow_right_dark,
  menu_arrow_right_blue,
  info,
  required,
  warning,
  trash_bin,
  pen_edit,
  pdf,
  link,
  profile,
  profile_dark,
  maximize_dark,
  minimize,
  trash_bin_dark,
  trash_red,
  link_dark,
  add_btn_dark,
  download_dark,
  minimize_dark,
  arrow_sort_down,
  arrow_sort_up,
  arrow_sort_down_dark,
  arrow_sort_up_dark,
  change_password,
  change_password_dark,
  event_groups_blue,
  event_groups_grey,
  event_persons_blue,
  event_persons_grey,
  event_users_blue,
  event_users_grey,
  remove,
  remove_dark,
  chart,
  chart_dark,
  vehicle,
  vehicle_dark,
  vehicle_grey,
  // Dashboard icons (Google Analytics style)
  dashboard,
  dashboard_dark,
  // Location icons (using existing icons)
  location: user,
  location_dark: user_dark,
  email_template,
  email_template_dark,
  send_acc,
  location_pin,
  camera,
  camera_dark,
  accreditation,
  accreditation_dark,
  generate_accr,
  generate_accr_dark,
  qr,
  edit_image,
  edit_image_dark,
  edit_image_blue,
  country,
  country_dark,
};
